// extracted by mini-css-extract-plugin
export default {"card":"DashboardCard_card__RKV8v","iconWrapper":"DashboardCard_iconWrapper__wR6tL","icon":"DashboardCard_icon__4FxcH","title":"DashboardCard_title__lPYJ7"};